<template>
  <div>
    <el-form label-position="right" label-width="95px" size="small">
      <el-row :gutter="0">
        <el-col :span="24">
          <!-- 退税报送 -->
          <el-form-item :label="$t('i18n_contact_person')">
            <div style="width: 100%; box-sizing: border-box">
              <div class="poperWrap" v-show="countLIst_D.name == ''">
                {{ $t("i18n_No_default_contact") }}
                <el-button
                  @click="addNewpop(1)"
                  type="text"
                  style="color: #604aff"
                  >{{ $t("i18n_add") }}</el-button
                >
              </div>
              <div class="thatpoperWrap" v-show="countLIst_D.name">
                <div class="popWrap_l">
                  <p class="lianxiren">{{ countLIst_D.name }}</p>
                  <p style="margin-left: 12px">{{ countLIst_D.tel }}</p>
                </div>
                <div class="popWrap_R">
                  <span class="morentype" v-show="countLIst_D.isdefault">{{
                    $t("i18n_default_address")
                  }}</span>
                  <el-button
                    v-show="!countLIst_D.isdefault"
                    style="color: #604aff"
                    type="text"
                    @click.stop="changeshowType(1, countLIst_D, 'loca')"
                    >{{ $t("i18n_set_to_default_address") }}</el-button
                  >
                  <el-button
                    style="color: #604aff"
                    type="text"
                    @click="UpItem(1, countLIst_D)"
                    >{{ $t("i18n_edit") }}</el-button
                  >
                  <el-button
                    @click="addNewpop(1)"
                    type="text"
                    style="color: #604aff"
                    >{{ $t("i18n_add") }}</el-button
                  >
                </div>
              </div>
              <!-- 退税报关人供选 -->
              <el-collapse-transition>
                <div v-show="showTui">
                  <div
                    class="poperWrap"
                    v-for="(item, index) in TuipopList"
                    :key="index"
                    @click="changeFAitem(item)"
                  >
                    <div class="popWrap_l">
                      <p class="lianxiren">{{ item.name }}</p>
                      <p style="margin-left: 12px">{{ item.tel }}</p>
                    </div>
                    <div class="popWrap_R">
                      <span class="morentype" v-show="item.isdefault">{{
                        $t("i18n_default_address")
                      }}</span>
                      <el-button
                        v-show="!item.isdefault"
                        style="color: #604aff"
                        type="text"
                        @click.stop="changeshowType(1, item, 'ajax')"
                        >{{ $t("i18n_set_to_default_address") }}</el-button
                      >
                      <el-button
                        style="color: #604aff"
                        type="text"
                        @click.stop="UpItem(1, item)"
                        >{{ $t("i18n_edit") }}</el-button
                      >
                    </div>
                  </div>
                </div>
              </el-collapse-transition>
            </div>
            <div style="margin: 10px 0 0 10px" v-show="TuipopList.length > 1">
              <el-button
                @click="showTui = !showTui"
                style="color: #696969"
                type="text"
                >{{
                  $t(
                    showTui ? "i18n_Collapse" : "i18n_more_contact_information"
                  )
                }}</el-button
              ><span
                :class="showTui ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
              ></span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <!-- 修改地址 -->
    <el-dialog
      class="dialog"
      width="420px"
      :visible.sync="addressDialogVisible"
      :closeOnClickModal="false"
      destroy-on-close
    >
      <div class="wrap_count">
        <div class="header_logo">
          {{
            $t(!this.itemid ? "i18n_Create_new_address" : "i18n_Modify_Address")
          }}
        </div>
        <div class="count">
          <el-form
            label-position="right"
            label-width="80px"
            :rules="fromPopRules"
            :model="fromPop"
            ref="editAddress"
          >
            <el-form-item :label="$t('i18n_contact_person')" prop="name">
              <el-input
                :placeholder="addPls('i18n_Name', 'input')"
                v-model="fromPop.name"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('i18n_contact_info')" prop="tel">
              <el-input
                :placeholder="addPls('i18n_contact_info', 'input')"
                v-model="fromPop.tel"
              ></el-input>
            </el-form-item>
            <!-- 国内省市区 -->
            <el-form-item
              :label="$t('i18n_contact_address')"
              v-if="changeNum == 2"
              prop="ssqnames"
            >
              <el-cascader
                style="width: 100%"
                ref="refSsqname"
                :options="Guojialist"
                v-model="fromPop.ssqnames"
                :props="defaultParams"
              >
                <template slot-scope="{ node, data }">
                  <span>{{ data.namec }}</span>
                  <span v-if="!node.isLeaf"></span>
                </template>
              </el-cascader>
            </el-form-item>
            <!-- 国外区域 -->
            <el-form-item
              :label="$t('i18n_contact_address')"
              v-if="changeNum == 3"
              prop="ssqnames"
            >
              <el-cascader
                style="width: 100%"
                ref="refSsqname"
                :options="citylist"
                v-model="fromPop.ssqnames"
                :props="defaultParams"
              >
                <template slot-scope="{ node, data }">
                  <span>{{ data.namec }}</span>
                  <span v-if="!node.isLeaf"></span>
                </template>
              </el-cascader>
            </el-form-item>
            <el-form-item v-show="changeNum != 1">
              <el-input
                :placeholder="addPls('i18n_Detailed_address', 'input')"
                type="textarea"
                v-model="fromPop.address"
              ></el-input>
            </el-form-item>
            <el-form-item prop="type">
              <el-checkbox-group v-model="fromPop.isdefault">
                <el-checkbox name="type">{{
                  $t("i18n_set_to_default_address")
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">{{
                $t(itemid ? "i18n_edit" : "i18n_add")
              }}</el-button>
              <el-button @click="addressDialogVisible = false">{{
                $t("i18n_cancel")
              }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs"
import { addPls } from '@/utils/placeholderI18n'
export default {
  props: {
    declarerDTO: {
      type: Object,
      default: {}
    },
  },
  data() {
    const phoneNumberValidate = (rule, value, callback) => {
      const reg = /^(1[3-9][3-9])\d{8}$/
      if (!reg.test(value)) {
        callback(new Error(this.$t('i18n_Please_enter_correct_cell_phone_number')))
      } else {
        callback()
      }
    }
    return {
      goodsTypeShow: false,
      TipopList: [],
      showReceive: false,
      SHpopList: [],
      //发货
      countLIst_D: {
        address: "",
        city: "",
        country: "",
        customerid: "",
        id: "",
        isdefault: false,
        name: "",
        tag: "",
        tel: "",
      },
      showTui: false,
      TuipopList: [],
      addressDialogVisible: false,
      citylist: [],
      itemid: '',
      fromPop: {
        address: "",
        parvince: "",
        city: "",
        area: "",
        country: "",
        customerid: null,
        id: "",
        isdefault: true,
        name: "",
        tag: "",
        tel: "",
        ssqnames: []
      },
      fromPopRules: {
        name: [{ required: true, message: this.addPls('i18n_contact_person', 'input'), trigger: 'blur' }],
        tel: [
          { required: true, message: this.addPls('i18n_Phone_number', 'input'), trigger: 'blur' },
          // { validator: phoneNumberValidate, trigger: 'blur' }
          { max: 20, message: this.$t('i18n_no_more_than_20_characters'), trigger: 'blur' }
        ],
        ssqnames: [{ required: true, message: this.$t('i18n_contact_address', 'input'), trigger: 'change' }],
        address: [{ required: true, message: this.addPls('i18n_Detailed_address', 'input'), trigger: 'change' }]
      },
      changeNum: null, //1 发货 2提货 3收货
      Guojialist: [],
      defaultParams: {
        //定义 联级选择器的 -省市区-和-收货地址-需获取name
        label: "namec",
        value: "namec",
        children: "children",
      },
      ssqnames: [],
      getGoodsDTORules: {
        getGoodsAddress: [{ required: true, message: this.addPls('i18n_pickup_location', 'select'), trigger: 'change' }],
        getGoodsName: [{ required: true, message: this.addPls('i18n_pickup_person', 'select'), trigger: 'change' }],
        getGoodsTel: [{ required: true, message: this.addPls('i18n_pickup_contact_number', 'select'), trigger: 'change' }],
        toDoorDate: [{ required: true, message: this.addPls('i18n_pickup_time', 'select'), trigger: 'change' }]
      },
      showMydialog: false,
      edit: false,
      nameOrPhone: '',
      submitForm: {
        address: '',
        area: '',
        city: '',
        customerid: 0,
        id: 0,
        isdefault: false,
        name: '',
        parvince: '',
        tag: '',
        tel: ''
      },
      getLIstType: 'PS',
      jackCitylist: [],
      value: [],
      tableData: [],
      tempTableData: [],
      defaultParams2: {
        value: "namec",
        label: "namec"
      }
    }
  },
  created() {
    this.getTuidata()
  },
  methods: {
    ShowTHList() {
      this.getPeopletable()
      this.showMydialog = true
    },
    getPeopletable() {
      //获取提货联系人
      let that = this;
      let customerId = sessionStorage.getItem("Authorization")
        ? JSON.parse(sessionStorage.getItem("Authorization")).customerid
        : "";
      let path = "addressListForDelivery";
      // if (this.getLIstType === "PS") {
      //   path = "addressListForConsigner";
      // } else {
      //   // 暂时不调这个接口
      //   return
      // }
      this.axios.get(`/customer/${path}/${customerId}`).then((res) => {
        if (res.data.code == "200") {
          // res.data.datas.forEach((item) => {
          //   this.$set(item, "changeType", false);
          // });
          this.tableData = res.data.datas;
          this.tempTableData = res.data.datas;
        } else {
        }
      })
        .catch((res) => { });
    },
    addNewpop(num) {
      this.itemid = "";
      this.changeNum = num;
      this.fromPop.name = "";
      this.fromPop.tel = "";
      this.ssqnames = [];
      this.fromPop.ssqnames = []
      this.fromPop.address = "";
      this.addressDialogVisible = true;
      if (num != "1") {
        //1是退税报关人 没有省市区
        this.getProvinces(num); //查询省市区
      }
    },
    changeShitem(item) { // 选择收货人
      console.log(item);
      this.sendFeeForAir = Object.assign(this.sendFeeForAir, item);
      this.showReceive = false;
      Object.keys(this.recGoodsDTO).map(key => {
        const itemKey = key.slice(8).toLowerCase()
        this.recGoodsDTO[key] = item[itemKey]
      })

      localStorage.setItem("sendFeeForAir", JSON.stringify(this.sendFeeForAir));

      // this.getPSFcount(); //重新计算配送费
    },
    changeFAitem(item) { // 选择退税报关人
      this.showTui = false;
      this.countLIst_D = item;
      localStorage.setItem("countLIst_D", JSON.stringify(item));
      Object.keys(this.declarerDTO).map(key => {
        const itemKey = key.slice(8).toLowerCase()
        this.declarerDTO[key] = item[itemKey]
      })
    },
    changeshowType(num, item, type) { //设为默认
      this.axios.post(
        `/customer/updateAddressDefault?${qs.stringify({
          addressId: item.id,
        })}`
      )
        .then((res) => {
          console.log(res);
          if (res.data.code == "200") {
            this.getTuidata();
            this.$message({ message: this.$t("i18n_Success"), type: "success" });
          } else {
            this.$message(res.data.message);
          }
        });
      if (num == 1 && type == "loca") {
        item.isdefault = true;
        let countLIst_D = JSON.parse(localStorage.getItem("countLIst_D"));
        countLIst_D.isdefault = true;
        localStorage.setItem("countLIst_D", JSON.stringify(countLIst_D));
      }
    },
    UpItem(num, item) { // 修改发货收货信息
      console.log(num);
      this.itemid = item.id;
      this.getProvinces(num);
      this.ssqnames = [];
      this.changeNum = num;
      this.addressDialogVisible = true;
      this.fromPop = JSON.parse(JSON.stringify(item));
      this.fromPop.ssqnames = []
      // console.log(this.fromPop);
      if (num == 2) {
        this.fromPop.ssqnames[0] = item.parvince;
        this.fromPop.ssqnames[1] = item.city;
        this.fromPop.ssqnames[2] = item.area;
      } else if (num == 3) {
        this.fromPop.ssqnames[0] = item.country;
        this.fromPop.ssqnames[1] = item.city;
        this.fromPop.ssqnames[2] = item.area;
      }
    },
    getProvinces(num) { //获取省市区和国外地址
      let url = "";
      if (num == 3) {
        //国外城市和区域 2是国外 3是国内
        url = "/filedata/findThirdLevelAddress";
        this.axios.post(url).then((res) => {
          console.log(res);
          if (res.data.code == "200") {
            this.citylist = res.data.datas;
            this.jackCitylist = res.data.datas;
          } else {
          }
        }).catch((res) => {
          console.log(res);
        });
      } else {
        //国内省市区
        url = "/filedata/filedataProvinces";
        this.axios.post(url).then((res) => {
          console.log(res);
          if (res.data.code == "200") {
            this.Guojialist = res.data.datas;
            this.jackCitylist = res.data.datas;
          } else {
          }
        }).catch((res) => {
          console.log(res);
        });
      }
    },
    onSubmit() {
      this.$refs.editAddress.validate(valid => {
        if (!valid) return
        let that = this;
        //changeNum //1 退税报关人 2提货3收货
        // if (!this.fromPop.name) return this.$message("请输入联系人姓名");
        // if (!this.fromPop.tel) return this.$message("请输入联系人电话");
        if (this.changeNum == 1) {
          //新增发货
          let params = {
            customerid: JSON.parse(sessionStorage.getItem("Authorization"))
              .customerid, //客户id
            id: this.itemid,
            isdefault: this.fromPop.isdefault,
            name: this.fromPop.name,
            tag: "",
            tel: this.fromPop.tel,
          };
          this.axios.post(`/customer/addOrUpdateDeclarer`, params).then((res) => {
            console.log(res);
            if (res.data.code == "200") {
              this.$message({ message: this.$t("i18n_Success"), type: "success" });
              if (this.countLIst_D.id == this.itemid) {
                //为了更新本地默认通讯录信息
                this.countLIst_D = params;
                localStorage.setItem("countLIst_D", JSON.stringify(params));
              }
              this.getTuidata();
              this.addressDialogVisible = false;
            } else {
              this.$message(res.data.message);
            }
          });
        }
      })
      console.log(this.changeNum);
    },
    // 显示新增
    showAdd(type) {
      if (type) {
        this.edit = true;
      } else {
        this.edit = false;
      }

      this.value = [];
      for (let key in this.submitForm) {
        this.submitForm[key] = "";
      }
    },
    // 模糊搜索
    searchNameOrPhone() {
      if (!this.nameOrPhone) {
        return this.getPeopletable();
      }
      let temp = [];

      this.tempTableData.forEach((item, index) => {
        if (
          item.name.indexOf(this.nameOrPhone) != -1 ||
          item.tel.indexOf(this.nameOrPhone) != -1
        ) {
          temp.push(item);
        }
      });
      this.tableData = temp;
    },
    getTuidata() {
      //退税报送人
      let customerId = JSON.parse(sessionStorage.getItem("Authorization"))
        .customerid;
      this.axios.get(`/customer/addressListForDeclarer/${customerId}`).then((res) => {
        if (res.data.code == "200") {
          this.TuipopList = res.data.datas;
          if (sessionStorage.getItem("countLIst_D") && this.declarerDTO.declarerName) {
            this.TuipopList.forEach(item => { // 更新当前退税报关人的默认状态
              if (item.id === this.countLIst_D.id) {
                this.countLIst_D = Object.assign(this.countLIst_D, item)
              }
            })
          } else {
            // 本地没有就循环数据索取默认
            res.data.datas.forEach((item) => {
              if (item.isdefault) {
                this.countLIst_D = item;
                Object.keys(this.declarerDTO).map(key => {
                  const itemKey = key.slice(8).toLowerCase()
                  this.declarerDTO[key] = item[itemKey]
                })
              }
            });
            localStorage.setItem(
              "countLIst_D",
              JSON.stringify(this.countLIst_D)
            );
          }
        } else {
        }
      })
        .catch((res) => {
          console.log(res);
        });
    },
    // 级联选择器方法
    handleChange(value) {
      // if (this.getLIstType === "PS") {
      //   this.submitForm.country = value[0];
      // } else {
      //   this.submitForm.parvince = value[0];
      // }
      this.submitForm.parvince = value[0];
      this.submitForm.city = value[1];
      this.submitForm.area = value[2];
    },
    // add
    addAddr(id) {
      if (!this.very()) {
        return;
      }
      if (!this.submitForm.id) {
        delete this.submitForm.id;
      }
      let user = sessionStorage.getItem("Authorization");
      user = JSON.parse(user);
      // 新增
      this.submitForm.customerid = user.customerid;
      // 判断是否是派送
      let path = "addOrUpdateDelivery";
      // if (this.getLIstType === "PS") {
      //   path = "addOrUpdateConsigner";
      // }
      this.axios.post(`/customer/${path}`, this.submitForm, {}).then((res) => {
        if (res.data.code == 200) {
          this.edit = false;
          this.value = [];
          this.getPeopletable();
          for (let key in this.submitForm) {
            this.submitForm[key] = "";
          }
        } else {
          this.$message.info(res.data.message);
        }
      })
        .catch((res) => { });
    },
    // 设为默认
    setDefault(item) {
      if (item.isdefault) {
        return this.$message.info("已经是默认地址");
      }
      this.axios.post(`/customer/updateAddressDefault?addressId=${item.id}`, {}).then((res) => {
        if (res.data.code == 200) {
          this.getPeopletable();
          this.$message.success("设置成功！");
        } else {
          this.$message.info(res.data.message);
        }
      })
        .catch((res) => { });
    },
    ShowTHList() {
      this.getPeopletable()
      this.showMydialog = true
    },
    //  edit
    handleEdit(index, item) {
      console.log('sss', item)
      this.value = [];
      let temp = JSON.stringify(item);
      this.getProvinces(2)
      this.submitForm = JSON.parse(temp);
      this.value.push(
        // this.getLIstType == "PS"
        //   ? this.submitForm.country
        //   : this.submitForm.parvince,
        this.submitForm.parvince,
        this.submitForm.city,
        this.submitForm.area
      );
      this.edit = true;
    },
    addPls,
  }
}
</script>

<style lang="scss" scoped>
.weituo {
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
  .addMore {
    display: flex;
    justify-content: flex-end;
    flex: 1;
  }
}
.tittype {
  font-size: 18px;
  font-family: Helvetica, "San Francisco", "Microsoft Yahei", 微软雅黑,
    "Heiti SC";
  font-weight: 500;
  color: #333333;
  margin-left: 10px;
}
.poperWrap {
  width: 100%;
  height: 40px;
  border: 1px solid #e6e6e6;
  padding: 13px;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  flex-flow: row nowrap;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.4s;
}
.poperWrap:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transform: scale(1.02);
}
.popWrap_l {
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.lianxiren {
  font-size: 18px;
  font-family: Helvetica, "San Francisco", "Microsoft Yahei", 微软雅黑,
    "Heiti SC";
  font-weight: bold;
  color: #343434;
  width: 70px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.overText {
  width: 210px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.morentype {
  height: 20px;
  background: #dedede;
  border-radius: 5px;
  color: #9a9a9a;
  padding: 2px;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  align-items: center;
}
.thatpoperWrap {
  width: 100%;
  height: 40px;
  border: 1px solid #5ab53c;
  background: #c7e4bd;
  padding: 13px;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.popWrap_R {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.dialog >>> .el-dialog__body {
  padding: 0px 30px 30px 30px !important;
}
.dialog >>> .el-dialog__header {
  padding: 10px !important;
}
.SHInfo {
  padding: 15px;
  border-radius: 5px;
  background-color: #fff6e6;
  color: #f79c00;
  &:first-child {
    margin-top: 5px;
  }
}
.dialog >>> .el-dialog__body {
  padding: 0px 30px 30px 30px !important;
}
.dialog >>> .el-dialog__header {
  padding: 10px !important;
}
.count {
  width: 100%;
  padding-top: 30px;
}
.wrap_count {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.header_logo {
  width: 100%;
  float: left;
  text-align: left;
}
.myDialog {
  border-radius: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/airOrder/component/addressInfoDeclarer.vue